const STUDIO_TRIAL_REGISTER_PLAN = 'studio-trial-register-plan-clicked';
const STUDIO_UPGRADE_PLAN_CLICKED = 'studio-upgrade-plan-clicked';
const CONTRACT_STUDIO_ACTIVATED = 'contract-studio-activated';
export var ContractActivationOrigins;
(function (ContractActivationOrigins) {
    ContractActivationOrigins["ApplicationList"] = "applicationList";
    ContractActivationOrigins["Builder"] = "builder";
    ContractActivationOrigins["ApplicationHome"] = "applicationHome";
})(ContractActivationOrigins || (ContractActivationOrigins = {}));
export class StudioSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.SegmentService.page({
            name: 'Builder',
            path: window.location.hash,
        });
    }
    trackTrialRegisterPlan(payload, success) {
        this.trackEvent(STUDIO_TRIAL_REGISTER_PLAN, {
            ...payload,
        }, success);
    }
    trackUpgradePlan(payload, success) {
        this.trackEvent(STUDIO_UPGRADE_PLAN_CLICKED, {
            ...payload,
        }, success);
    }
    trackContractStudioActivated(payload, success) {
        this.trackEvent(CONTRACT_STUDIO_ACTIVATED, {
            ...payload,
        }, success);
    }
    trackEvent(event, properties, success) {
        if (properties?.origin === 'navBar') {
            this.SegmentService.createTrack(event, {
                ...properties,
                success,
            });
        }
        else {
            this.SegmentService.createOrganizationTrack(event, {
                ...properties,
                success,
            });
        }
    }
}
StudioSegmentService.$inject = ['SegmentService'];
